// CalendarioView.jsx — amm-v3 (A3, ondata 30): la vista "Calendario scadenze"
// (pagina 'calendario') in React, flag-gated (shell_amm_v3_calendario,
// default OFF).
//
// Replica 1:1 renderCalendario di admin-module.js r.1517-1577: stesso titolo,
// stesso bottone '+ Scadenza', stessa barra di navigazione mese (‹ › +
// etichetta MESI_L + Oggi + chip 'Solo scadute' condiviso col Cruscotto,
// A5-043), stessa griglia lunedì-prima di 42 celle (mese fuori attenuato,
// oggi bordato), stessi chip evento (max 3 per cella, colori urgenza dal v1)
// e stesso link '+N altre' col popover del giorno (A3-054).
//
// La griglia è il componente condiviso client/src/ui/MonthGrid.jsx (NUOVO
// mattone del design system, stati obbligatori inclusi); la matematica vive
// in month-grid-core.js (pura, replica testata del v1). DELEGHE: modale
// scadenza = AMM.openEditor (post-save ridipinge via renderPage: passa dal
// wrap, NIENTE interceptor — censimento nel contract test), popover =
// AMM.apriGiornoPopover, colori = AMM.urgency, 'oggi' = AMM.isoToday.
//
// STATO (parità di persistenza col v1):
//  - il mese vive su AMM.cal (lazy-init identico a r.1519) e il filtro
//    'Solo scadute' su AMM.filterScadute: CONDIVISI col v1 e col Cruscotto —
//    flip di flag senza perdere posizione/filtri;
//  - COMMIT ATOMICO come il v1: durante il fetch di un altro mese la griglia
//    E l'etichetta restano sul mese precedente (il v1 sostituisce l'HTML solo
//    DOPO l'await, r.1526→1546); qui {y, m, rows} committano insieme.
//
// DEVIAZIONI DICHIARATE (v3 non bug-compatibile qui):
//  D-A3.1 navigazione rapida prev/next: committa SOLO l'ultimo mese richiesto
//         (stale-guard); il v1 committa in ordine di risposta delle fetch
//         (stesso stato finale, mai frame intermedi fuori ordine).
//  D-A3.2 a ricarica fallita con griglia già a schermo: banner 'Dati non
//         aggiornati' + Riprova, griglia conservata (famiglia D-A1.5/D-A2.2;
//         il v1 sostituirebbe l'intera pagina con 'Errore: …').

import React from 'react';
import { MonthGrid } from '../ui/MonthGrid.jsx';
import { buildCells, groupByDay, shiftMonth } from '../ui/month-grid-core.js';
import { AM_NEW_TEXTS } from './api.js';
import {
  AC_TEXTS, MESI_L, DOW, AC_CHIP_ATTIVO,
  calStato, filtraScadute, chipScadenza, moreLabel, readCalendario,
  apriEditor, apriNuova, apriPopoverGiorno,
} from './calendario-api.js';

export function CalendarioView({ win, tick }) {
  const A = win.AMM;
  // pending = mese richiesto (specchiato su AMM.cal, write-through);
  // dati.vista = ultimo mese COMMITTATO {y, m, rows} (parità v1: la griglia
  // cambia solo a fetch concluso)
  const [pending, setPendingState] = React.useState(() => ({ ...calStato(A) }));
  const setPending = (next) => {
    A.cal = { y: next.y, m: next.m }; // write-through (r.1558-1560 mutano self.cal)
    setPendingState(next);
  };
  // navigazione RELATIVA: parte SEMPRE da A.cal (scritto in modo sincrono a
  // ogni click) e non dallo stato React del render — due click rapidi su ›
  // avanzano di DUE mesi come nel v1 (self.cal.m++ muta l'oggetto condiviso),
  // mai di uno solo per closure stantia.
  const navMese = (delta) => setPending(shiftMonth(calStato(A), delta));
  const [dati, setDati] = React.useState({ loading: true, error: null, vista: null });
  const [reloadN, setReloadN] = React.useState(0);
  const [soloScadute, setSoloScaduteState] = React.useState(() => !!A.filterScadute);
  const setSoloScadute = (v) => {
    A.filterScadute = v; // stato UNICO nel modulo, condiviso col Cruscotto (A5-043)
    setSoloScaduteState(v);
    setReloadN((n) => n + 1); // stessa via del v1: il toggle ridisegna (e rifetcha) la griglia
  };

  React.useEffect(() => {
    let vivo = true;
    const y = pending.y;
    const m = pending.m;
    setDati((d) => ({ ...d, loading: true, error: null }));
    readCalendario(win, y, m).then(
      (rows) => { if (vivo) setDati({ loading: false, error: null, vista: { y, m, rows } }); },
      (e) => { if (vivo) setDati((d) => ({ ...d, loading: false, error: e })); }
    );
    return () => { vivo = false; }; // D-A3.1: solo l'ultimo mese richiesto committa
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [win, tick, reloadN, pending.y, pending.m]);

  const vista = dati.vista;
  // etichetta e griglia dal mese COMMITTATO (parità v1); al primo giro (vista
  // assente) l'etichetta mostra il mese richiesto sopra lo stato loading
  const labelY = vista ? vista.y : pending.y;
  const labelM = vista ? vista.m : pending.m;
  const cells = vista ? buildCells(vista.y, vista.m, A.isoToday()) : null;
  const shown = vista ? filtraScadute(vista.rows, soloScadute, (s) => A.isScaduta(s)) : [];
  const byDay = groupByDay(shown);

  return (
    <div data-amm-v3="calendario">
      <div className="flex items-center justify-between mb-3">
        <h1 className="text-xl font-semibold">{AC_TEXTS.title}</h1>
        <button
          id="amm-scad-new"
          type="button"
          className="bg-cyan-700 hover:bg-cyan-600 text-white text-xs px-3 py-2 rounded font-medium"
          onClick={() => apriNuova(win)}
        >{AC_TEXTS.nuovaScadenza}</button>
      </div>
      <div className="flex items-center gap-3 mb-3">
        <button id="amm-prev" type="button" className="w-8 h-8 border rounded bg-white hover:bg-slate-50" onClick={() => navMese(-1)}>{'‹'}</button>
        <button id="amm-next" type="button" className="w-8 h-8 border rounded bg-white hover:bg-slate-50" onClick={() => navMese(1)}>{'›'}</button>
        <div className="text-base font-medium" style={{ minWidth: 150 }}>{MESI_L[labelM] + ' ' + labelY}</div>
        <button
          id="amm-oggi"
          type="button"
          className="bg-slate-200 hover:bg-slate-300 text-slate-800 text-xs px-3 py-2 rounded font-medium"
          onClick={() => { const n = new Date(); setPending({ y: n.getFullYear(), m: n.getMonth() }); }}
        >{AC_TEXTS.oggi}</button>
        <span
          id="amm-chip-scadute"
          className={'amm-fchip cursor-pointer text-xs px-3 py-1.5 rounded-full border' + (soloScadute ? '' : ' bg-white text-slate-600 border-slate-200')}
          style={soloScadute ? { background: AC_CHIP_ATTIVO.background, color: AC_CHIP_ATTIVO.color, borderColor: AC_CHIP_ATTIVO.borderColor } : undefined}
          onClick={() => setSoloScadute(!soloScadute)}
        >{AC_TEXTS.soloScadute}</span>
      </div>

      {/* D-A3.2 (famiglia D-A1.5/D-A2.2): ricarica fallita con griglia presente
          ⇒ errore DICHIARATO col banner + Riprova, griglia conservata */}
      {dati.error && vista && (
        <div role="alert" className="mb-3 px-4 py-2.5 rounded-lg text-sm font-medium flex items-center justify-between gap-3" style={{ background: '#fef2f2', color: '#b91c1c', border: '1px solid #fecaca' }}>
          <span>{AM_NEW_TEXTS.erroreRicarica + (dati.error.message || String(dati.error))}</span>
          <button
            type="button"
            style={{ background: '#0e7490', color: '#fff', border: 0, borderRadius: 8, padding: '6px 14px', fontWeight: 600, cursor: 'pointer', fontSize: 13 }}
            onClick={() => setReloadN((n) => n + 1)}
          >{AM_NEW_TEXTS.riprova}</button>
        </div>
      )}

      <MonthGrid
        cells={cells}
        dow={DOW}
        eventsByDay={byDay}
        maxPerCell={3}
        chip={(s) => chipScadenza(A, s)}
        onChipClick={(s) => apriEditor(win, s)}
        moreLabel={moreLabel}
        onMoreClick={(iso, evs, anchor, e) => { e.stopPropagation(); apriPopoverGiorno(win, evs, anchor); }}
        loading={dati.loading}
        error={vista ? null : dati.error}
        onRetry={() => setReloadN((n) => n + 1)}
      />
    </div>
  );
}

// Factory (pattern createAmmV3Cruscotto): install.js la registra nel registry
// del wrap di AMM.renderPage. render() è idempotente sul container #amm-page;
// unmount() libera il container (il v1 resta vivo per le altre pagine).
export function createAmmV3Calendario(win) {
  let root = null;
  let mountedEl = null;
  let tick = 0;

  function render() {
    const container = win.document.getElementById('amm-page');
    if (!container) throw new Error('#amm-page assente');
    const manomesso = root && mountedEl === container && tick > 0
      && !container.querySelector('[data-amm-v3]');
    if (!root || mountedEl !== container || !container.isConnected || manomesso) {
      if (root) { try { root.unmount(); } catch (e) { /* root già ferito/smontato */ } }
      container.replaceChildren();
      root = win.ReactDOM.createRoot(container);
      mountedEl = container;
    }
    tick += 1; // ogni chiamata del wrapper = refresh dati (nav, rientro, post-azione)
    root.render(<CalendarioView win={win} tick={tick} />);
  }

  function unmount() {
    if (root) {
      try { root.unmount(); } catch (e) { /* già smontato */ }
      root = null;
    }
    mountedEl = null;
  }

  function isMounted() { return !!root; }

  return { render, unmount, isMounted };
}
